import { render, staticRenderFns } from "./baseDetail.vue?vue&type=template&id=3b0b8f5d&scoped=true"
import script from "./baseDetail.vue?vue&type=script&lang=js"
export * from "./baseDetail.vue?vue&type=script&lang=js"
import style0 from "./baseDetail.vue?vue&type=style&index=0&id=3b0b8f5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b8f5d",
  null
  
)

export default component.exports